import { invoiceFragment } from "@saleor/fragments/orders";
import gql from "graphql-tag";

export const checkExportFileStatus = gql`
  query CheckExportFileStatus($id: ID!) {
    exportFile(id: $id) {
      id
      status
    }
  }
`;

export const checkOrderInvoicesStatus = gql`
  ${invoiceFragment}
  query CheckOrderInvoicesStatus($id: ID!) {
    order(id: $id) {
      id
      invoices {
        ...InvoiceFragment
      }
    }
  }
`;

export const checkUploadStatus = gql`
  query ProductUploadJob($id: ID!) {
    productUploadJob(id: $id) {
      id
      status
      errorFileUrl
    }
  }
`;

export const checkShopifySyncStatus = gql`
  query CheckShopifySyncStatus($id: UUID!) {
    shopifyBrandSyncJob(pid: $id) {
      id
      status
    }
  }
`;

export const checkVoucherJob = gql`
  query CheckVoucherJob($id: ID!) {
    voucherJob(id: $id) {
      id
      status
      message
    }
  }
`;

export const checkVoucherJobBulk = gql`
  query CheckVoucherJobBulk($id: ID!) {
    voucherJobBulk(id: $id) {
      id
      status
      message
    }
  }
`;
